export const privacySubtitleObject = {
  lightBg: true,
  lightText: false,
  subtitle: "プライバシーポリシー",
  topLine: "PRIVACY POLICY",
};

export const privacyTextSectionObject = {
  lightBg: true,
  lightText: false,
  text: "test",
};
